// material
import { Box, Link, Tooltip, Typography } from '@mui/material';
import { isString } from 'lodash';
import { ReactNode } from 'react';
import { AuthService } from '_apis_/auth';
import { MBreadcrumbs, MBreadcrumbsProps } from 'components';
import { InfoIcon } from 'theme/overrides/CustomIcons';

// ----------------------------------------------------------------------

interface HeaderBreadcrumbsProps extends MBreadcrumbsProps {
  action?: ReactNode;
  heading: string;
  moreLink?: string | string[];
  tooltip?: string | null;
}

export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  moreLink = '' || [],
  sx,
  tooltip = '',
  ...other
}: HeaderBreadcrumbsProps) {
  const authService = new AuthService();
  const ableToRedirect = authService.roleId !== 3;
  return (
    <Box sx={{ mb: 5, ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h4"
            gutterBottom
            data-testid="page-header"
            style={{
              display: 'flex',
              alignItems: 'center',
              width: `${200 + heading.length * 10}px`
            }}
          >
            {heading}
            {tooltip && (
              <Tooltip title={tooltip || ''}>
                <span>
                  <InfoIcon sx={{ marginLeft: 1, marginTop: '10px !important', width: '0.8em' }} />
                </span>
              </Tooltip>
            )}
          </Typography>
          <MBreadcrumbs links={links} ableToRedirect={ableToRedirect} {...other} />
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>

      <Box sx={{ mt: 2 }}>
        {isString(moreLink) ? (
          <Link href={moreLink} target="_blank" variant="body2">
            {moreLink}
          </Link>
        ) : (
          moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))
        )}
      </Box>
    </Box>
  );
}
